import { jsx as _jsx } from "react/jsx-runtime";
import { OpenInNewTab } from 'seagull/icons';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { Accounting } from '~/types/api.model';
export const TimeActivityExternalLink = (param)=>{
    let { timeActivity } = param;
    return /*#__PURE__*/ _jsx(ExternalLinkButton, {
        href: timeActivity.url,
        testId: "time-activity-".concat(timeActivity.id, "-external-link"),
        tooltip: {
            title: "Open Time Activity in ".concat(getAccountingDetails(Accounting.QBO).fullName),
            placement: 'top'
        },
        openInNewTab: true,
        children: /*#__PURE__*/ _jsx(OpenInNewTab, {})
    });
};
